import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductDetailUpdatedRoutingModule } from './product-detail-updated-routing.module';
import { MProductModal } from '../product/product.module';
import { MCustomerDetailResponseData } from '../user/user.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ProductDetailUpdatedRoutingModule
  ]
})
export class ProductDetailUpdatedModule { }


export class MBrandTypeMappingRequest {
  "brand_Ids": any
  "category_ids": any
  "product_ids": any
  "type": any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MAddUpdateCartModule {
  id: any
  product_id!: number
  user_id!: string
  qty!: number
  iswishlistitem!: boolean
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MAddUpdateCartModuleResponse {
  "statusCode": number
  "message": string
  "totalRecords": number
  "data": [MAddUpdateCartModuleResponseData]
  "token": string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MAddUpdateCartModuleResponseData {
  "productdetail": MProductModal
  "id": string
  "user_id": string
  "product_id": number
  "qty": number
  "iswishlist": boolean
  "created_by": string
  "modified_by": string
  "created_at": string
  "modified_at": string
  "customer_detail": MCustomerDetailResponseData
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
